import { useQuery } from 'react-query';

import { getCardTypes as queryFn } from 'api/endPoints/getCardTypes';
import { IVersion } from 'api/queries/getProjectVersionsList.query';
import { QueryKeys } from 'api/queryKeys';

import { ICardActivityCode } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/battlecards.types';

export const useQueryGetCardTypes = (params: QueryParams) => {
    return useQuery<ICardActivityCode[], QueryError, ICardActivityCode[], [QueryKeys, unknown]>({
        queryKey: ['getCardTypes', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.metaDataId),
    });
};

export interface QueryParams {
    metaDataId?: IVersion['id'];
}
